<template>
  <div class="squircle-lg rounded border p-3">
    <h4 class="text-sm leading-tight font-semibold">
      {{ name }}
    </h4>
    <span>{{ $t('global.available') }} : {{ quantityAvailable }}</span>
    <div>
      <QuantityInput
        v-model="localQuantity"
        :disable-add-button="disableAddButton"
        :max-quantity="quantityAvailable"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import QuantityInput from '@ui/QuantityInput.vue'

export default defineComponent({
  name: 'StockSelectInStock',
  components: { QuantityInput },
  props: {
    name: {
      type: String,
      required: true
    },
    quantityAvailable: {
      type: Number,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    disableAddButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:quantity'],
  computed: {
    localQuantity: {
      get() {
        return this.quantity
      },
      set(value) {
        this.$emit('update:quantity', value)
      }
    }
  }
})
</script>

<style scoped></style>
